// actions.js
import axios from "axios";
import { apis, serverCall } from "../../../utils/api/constant";
import {
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  GET_DATA_DISCONNETION_RULES_RESET,
  FETCH_DATA_FAILURE,
  GET_DATA_CUSTOMER,
  SET_DATA_DISCONNETION,
  GET_DATA_PENDING_CONNECTION_DETAILS,
  GET_DATA_CUSTOMER_DETAILS,
  SET_DATA_DISCONNETION_REMARK,
  CLEAR_ALL_DATA,
  GET_DATA_EVENT,
  GET_DATA_DISCONNETION_RULES,
} from "./action";
import { logOut } from "../../../Logout";

export const fetchDataServiceMeterCategory = (userData) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.FETCH_DATA_CATEGORY,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 1,
          param1: 1,
          param2: 0,
          param3: 0,
          param4: "",
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      // Check the response and run logout if error
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }

      dispatch({ type: FETCH_DATA_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

// Set customer data
export const getCustomer = (userData, consumerNum) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.FETCH_DATA_CATEGORY,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 2,
          param1: consumerNum,
          param2: 0,
          param3: 0,
          param4: userData?.pDATASET[0]?.CIRCLE_CODE,
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      // Check the response and run logout if error
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: GET_DATA_CUSTOMER, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

// Set customer data
export const getCustomerDetails = (userData, details) => {

  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      //let response = await serverCall(apis.FETCH_DATA_CATEGORY, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID":4, "param1": 234 ,"param2": 12455, "param3": 0, "param4": "123456", "param5": 123 , "param6": ""}, { "sid": userData.token });
      let response = await serverCall(
        apis.FETCH_DATA_CATEGORY,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 4,
          param1: details.customerId,
          param2: details.meterId,
          param3: 0,
          param4: "",
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      // Check the response and run logout if error
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: GET_DATA_CUSTOMER_DETAILS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const setDisconnectionRequestWithRemark = (userData, data) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.DISCONNECTION_REQUEST,
        "POST",
        { userName: userData?.pDATASET[0]?.USERNAME, apiID: 2, data: data },
        { sid: userData.token }
      );
      // Check the response and run logout if error
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: SET_DATA_DISCONNETION_REMARK, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const clearCustomerDetails = (userData) => {
  return async (dispatch) => dispatch({ type: CLEAR_ALL_DATA, payload: [] });
};

// Set customer data
export const pendingConnectionDetails = (userData, details) => {
  console.log(details);
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      //let response = await serverCall(apis.FETCH_DATA_CATEGORY, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID":5, "param1": "2031" ,"param2": "2031", "param3": 0, "param4": "03-10-24", "param5": '13-10-24' , "param6": ""}, { "sid": userData.token });
      let response = await serverCall(
        apis.FETCH_DATA_CATEGORY,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 5,
          param1: details.consumerNumber,
          param2: details.consumerNumber,
          param3: 0,
          param4: details.toStart,
          param5: details.toEnd,
          param6: "",
        },
        { sid: userData.token }
      );
      // Check the response and run logout if error
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: GET_DATA_CUSTOMER_DETAILS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const setDisconnectionRequest = (userData, data) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.DISCONNECTION_REQUEST,
        "POST",
        { userName: userData?.pDATASET[0]?.USERNAME, apiID: 1, data: data },
        { sid: userData.token }
      );
      // Check the response and run logout if error
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: SET_DATA_DISCONNETION, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const getDisconnectionRequest = (
  userData,
  ServiceCategory,
  MeterCategory
) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.FETCH_DATA_CATEGORY,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 3,
          param1: ServiceCategory,
          param2: MeterCategory,
          param3: 0,
          param4: userData?.pDATASET[0]?.CIRCLE_CODE,
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      // dispatch({ type: GET_DATA_DISCONNETION_RULES_RESET, payload: response.data });
      // logOut(response.data)
      dispatch({ type: GET_DATA_DISCONNETION_RULES, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const fetchDataEvent = (userData) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.FETCH_DATA_CATEGORY,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 6,
          param1: 0,
          param2: 0,
          param3: 0,
          param4: "",
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      console.log(response, "userName");
      // Check the response and run logout if error
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: GET_DATA_EVENT, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const disconnectionReConnectionDetails = (userData, details) => {
  console.log(details);
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      //let response = await serverCall(apis.FETCH_DATA_CATEGORY, "POST", { "userName": 'WBADMIN', "apiID":5, "param1": details.eventType ,"param2": "2031", "param3": 0, "param4": "03-08-24", "param5": '15-10-24' , "param6": ""}, { "sid": userData.token });
      let response = await serverCall(
        apis.FETCH_DATA_CATEGORY,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 7,
          param1: details.eventType,
          param2: details.customer_id,
          param3: details.meterid,
          param4: details.toStart,
          param5: details.toEnd,
          param6: "",
        },
        { sid: userData.token }
      );
      // logOut(response.data)
      dispatch({ type: GET_DATA_CUSTOMER_DETAILS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};
